exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-233545d1] {\n  border-bottom: unset !important;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.header .burger[data-v-233545d1] {\n  padding: unset;\n}\n.bg-outside[data-v-233545d1] {\n  width: 210px;\n  height: 60px;\n  cursor: pointer;\n}\n.icon-navbar-size[data-v-233545d1] {\n  height: 21px;\n}\n.icon-navbar-color[data-v-233545d1]:hover {\n  filter: brightness(0) saturate(100%) invert(23%) sepia(82%) saturate(2636%) hue-rotate(348deg) brightness(83%) contrast(86%);\n}", ""]);

// exports
